import instance from "../config";

// Escrutinio de mesa (acta E-14). Todos lanzan el error para mostrar el
// mensaje del backend ({ error } o { errors: [{ msg }] }).

// listado sin foto -> { escrutinios: [...] }
export const getEscrutinios = async (params) => {
  const { data } = await instance.get("/escrutinio", { params });
  return data;
};

// escrutinio de una mesa -> { escrutinio } (null si aún no se registra)
export const getEscrutinioMesa = async (corporacion, lugar, mesa) => {
  const { data } = await instance.get("/escrutinio/mesa", { params: { corporacion, lugar, mesa } });
  return data;
};

// foto del E-14 -> { foto } (data URL)
export const getFotoEscrutinio = async (id) => {
  const { data } = await instance.get("/escrutinio/foto", { params: { id } });
  return data;
};

// crea o actualiza el escrutinio abierto -> { msg, escrutinio }
export const guardarEscrutinio = async (datos) => {
  const { data } = await instance.post("/escrutinio", datos);
  return data;
};

// foto del acta que se cerró sin ella -> { msg, escrutinio }
export const cargarFotoEscrutinio = async (id, foto) => {
  const { data } = await instance.put(`/escrutinio/foto?id=${id}`, { foto });
  return data;
};

// datos: { observacion, tieneProblema, reconteoSolicitadoPor, reconteoEnRepresentacionDe }
export const cerrarEscrutinio = async (id, datos) => {
  const { data } = await instance.put(`/escrutinio/cerrar?id=${id}`, datos);
  return data;
};

// solo admin
export const reabrirEscrutinio = async (id) => {
  const { data } = await instance.put(`/escrutinio/reabrir?id=${id}`);
  return data;
};
